<template>
  <div class="container pb-4 mb-4">
        
    <div class="row pb-2">
        <div class="col text-center"><h5>Buy Clicks</h5></div>
      </div>
     
    <b-card no-body class="card">
      <b-tabs v-model="tabIndex" card align="center">
        
        
      </b-tabs>
    </b-card>

</div>

</template> 

<script>
export default {

  data() {
    return {
        tabIndex: 0,
    };
  },

}
</script>